import {
  BackgroundColors,
  NegativeColors,
  PositiveColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';

import { ColorSchemes } from 'redesignedComponents/context/colorScheme/enums';
import type { ColorSchemeType } from 'redesignedComponents/context/colorScheme/types';

interface propsType {
  colorScheme?: ColorSchemeType;
}

const useStyles = createUseStyles<string, propsType>(
  () => ({
    root: ({ colorScheme }) => ({
      height: 400,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        height: 'auto',
      },
      position: 'relative',
      backgroundColor:
        colorScheme === ColorSchemes.LIGHT
          ? PositiveColors.base.default
          : NegativeColors.base.default,
      color:
        colorScheme === ColorSchemes.LIGHT
          ? PositiveColors.text.default
          : NegativeColors.text.default,
      textAlign: 'center',
      paddingTop: Spacings.s40,
    }),
    items: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    carouselContainer: {
      '&&': {
        overflow: 'visible',
      },
    },
    carouselControl: {
      '&&': {
        alignItems: 'center',
        padding: 0,

        '&.prev': {
          left: `calc(${Spacings.s32} * -1)`,

          // [mediaQuery(BreakPoints.Small)]: {
          '@media screen and (max-width: 766px)': {
            left: `calc(${Spacings.s8} * -1)`,
          },
        },

        '&.next': {
          right: `calc(${Spacings.s32} * -1)`,

          // [mediaQuery(BreakPoints.Small)]: {
          '@media screen and (max-width: 766px)': {
            right: `calc(${Spacings.s8} * -1)`,
          },
        },
        '& > button': {
          height: '100%',
          '& i': {
            width: 24,
            height: 24,
            padding: Spacings.s2,
            background: BackgroundColors.tint1,
            borderRadius: CornerRadius.r16,
          },
          '& svg': {
            '& > path': {
              fill: PositiveColors.text.default,
            },
          },
        },
        '&.disabled': {
          visibility: 'hidden',
          opacity: 0,
        },
      },
    },
    background: {
      zIndex: 1,
    },
    skeletonRoot: {
      extend: 'root',
      position: 'relative',
      height: 400,
      width: '100%',
      paddingTop: Spacings.s72,
    },
    skeletonItems: {
      extend: 'items',
    },
    skeletonCarouselItem: {
      height: 200,
      maxWidth: 200,
    },
  }),
  {
    name: 'value-itemisation',
  },
);

export const useItemStyles = createUseStyles<string, { hasCta?: boolean }>(
  () => ({
    root: ({ hasCta }) => ({
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: [Spacings.s40, Spacings.s4],
      borderRadius: hasCta ? CornerRadius.r24 : CornerRadius.r0,
      textAlign: 'center',
    }),
    image: ({ hasCta }) => ({
      width: hasCta ? '80%' : 96,
      height: hasCta ? 'auto' : 96,
      margin: [0, 'auto', Spacings.s24, 'auto'],
    }),
    title: {
      marginBottom: Spacings.s4,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
      fontWeight: FontWeights.semibold,
    },

    skeletonWidth: {
      width: 200,
    },
    skeletonValueItemRoot: {
      extend: 'root',
    },
    skeletonImage: {
      extend: 'image',
      width: 350,
      height: 220,
      borderRadius: CornerRadius.r12,
    },
    skeletonText: {
      extend: 'skeletonWidth',
      height: 20,
      borderRadius: CornerRadius.r12,
      margin: '20px auto',
    },
    skeletonButton: {
      extend: 'skeletonWidth',
      height: 40,
      borderRadius: CornerRadius.r12,
      margin: '20px auto',
    },
  }),
  {
    name: 'value-itemisation-item',
  },
);

export default useStyles;
